import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsAccordionModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsCaEvaluationToolbarModule } from '../evaluation/component/toolbar/toolbar.module';
import { CmpsCaScoreSectionModule } from '../score-section';

import { FocusComponent } from './component/focus/focus.component';
import { MainComponent } from './component/main/main.component';
import { PhaseContentComponent } from './component/phase-content/phase-content.component';
import { PhaseHeaderComponent } from './component/phase-header/phase-header.component';

@NgModule({
    declarations: [
        FocusComponent,
        MainComponent,
        PhaseContentComponent,
        PhaseHeaderComponent,
    ],
    exports: [MainComponent],
    imports: [
        CmpsAccordionModule,
        CmpsCaEvaluationToolbarModule,
        CmpsCaScoreSectionModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsCaEvaluationResultModule {}
